module.exports = __webpack_public_path__ + "static/media/thanks.1a58702e.png";